import { useInfiniteQuery, useQuery } from 'react-query';
import { QueryKeys } from '../../../core/queries/query-keys.constants';
import { useApi } from '../../../core/api/api.context';
import { KioskState } from './types/kiosk.types';

export function useQueryKioskStates(projectID: string) {
  const api = useApi();

  return useInfiniteQuery(
    [QueryKeys.REPORTS, 'KIOSK_STATUS', projectID],
    async ({ pageParam = 0 }) => {
      const result = await api.kiosksController.getConnectionStates({
        pageNo: pageParam,
        perPageRecords: 20,
        projectID
      });
      return { ...result, items: result.items || [] };
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      getNextPageParam(lastPage) {
        if (lastPage.pageNo < lastPage.totalPages) {
          return lastPage.pageNo + 1;
        } else {
          return undefined;
        }
      }
    }
  );
}

export function useQueryKioskConnectionHistory(kioskId: string) {
  const api = useApi();

  return useQuery(
    [QueryKeys.REPORTS, 'KIOSK_STATUS', kioskId],
    async () => {
      // Fetch all kiosk states and filter by kioskId
      let hasMore = true;
      let page = 0;

      while (hasMore) {
        const response = await api.kiosksController.getConnectionStates({
          pageNo: page,
          perPageRecords: 20
        });
        const kioskState = response.items?.find((item: KioskState) => item.id === kioskId);

        if (kioskState) {
          return kioskState;
        }

        if (page > response.totalPages) {
          hasMore = false;
        }

        page++;
      }

      return;
    },
    {
      enabled: !!kioskId,
      retry: false,
      refetchOnWindowFocus: false
    }
  );
}
